/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/react-in-jsx-scope */
import PropTypes from 'prop-types';
import './AppBottomSheet.scss';

function AppBottomSheet({ isOpen, height, children, className, maxHeight }) {
  return (
    <div className={`app-bottom-sheet ${className}`}>
      {isOpen && (
        <div className={`modal-overlay ${isOpen ? 'active ' : ''}`}>
          <div
            style={{ height, maxHeight }}
            className={`bs-modal ${isOpen ? 'slide-in-bottom' : ''}`}
          >
            {children}
          </div>
        </div>
      )}
    </div>
  );
}

AppBottomSheet.defaultProps = {
  height: '50%',
  maxHeight: '90%',
};

AppBottomSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  height: PropTypes.string,
  maxHeight: PropTypes.string,
  className: PropTypes.string,
};

export default AppBottomSheet;
